import React, { FC, useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { WarehouseType } from '@app/api/models/distributor';
import { useApi, useFetchData } from '@app/hooks';

import { useColumns } from './columns';
import { EditWarehouseType } from './edit';

export const WarehouseTypesTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData<WarehouseType>({
    method: () => api.distributors.getWarehouseTypes().then((res) => ({ 
      data: {
        data: res.data, 
        total: res.data?.length || 0 
      },
      message: res.message,
      code: res.code,
    })),
  });
  const [editOpen, setEditOpen] = useState(false);
  const [operatedItem, setOperatedItem] = useState<WarehouseType>();

  const columns = useColumns({
    onEdit: (item) => {
      setOperatedItem(item);
      setEditOpen(true);
    },
  });

  return (
    <QueryTable
      title="Типы складов"
      columns={columns}
      fetchData={fetchData}
      onCreateClick={() => {
        setOperatedItem(undefined);
        setEditOpen(true);
      }}
      noPagination
    >
      <EditWarehouseType
        open={editOpen}
        setOpen={() => setEditOpen(false)}
        initial={operatedItem}
      />
    </QueryTable>
  );
};
